import { render, staticRenderFns } from "./AccrueCompanyPoints.vue?vue&type=template&id=b5cc5d00"
import script from "./AccrueCompanyPoints.vue?vue&type=script&lang=js"
export * from "./AccrueCompanyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports